"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StUSDAdapter__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_correlatedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608034608657601f6101d538819003918201601f19168301916001600160401b03831184841017608b578084926040948552833981010312608657604b602060458360a1565b920160a1565b600180546001600160a01b039384166001600160a01b0319918216179091556000805492909316911617905560405161012090816100b58239f35b600080fd5b634e487b7160e01b600052604160045260246000fd5b51906001600160a01b038216820360865756fe6080806040526004361015601257600080fd5b60003560e01c633ba0b9a914602657600080fd5b3460e557600036600319011260e55760015463266d6a8360e11b8252670de0b6b3a76400006004830152602090829060249082906001600160a01b03165afa90811560d957600091607d575b602082604051908152f35b60203d60201160d3575b601f8101601f1916820167ffffffffffffffff81118382101760bf5760209183916040528101031260bb5751905060206072565b5080fd5b634e487b7160e01b84526041600452602484fd5b503d6087565b6040513d6000823e3d90fd5b600080fdfea26469706673582212205150c4921ede80ece54174b126d4e5d47111600dcaa06508eac76a21fdb00fd264736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class StUSDAdapter__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_correlatedToken, _underlyingToken, overrides) {
        return super.getDeployTransaction(_correlatedToken, _underlyingToken, overrides || {});
    }
    deploy(_correlatedToken, _underlyingToken, overrides) {
        return super.deploy(_correlatedToken, _underlyingToken, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.StUSDAdapter__factory = StUSDAdapter__factory;
StUSDAdapter__factory.bytecode = _bytecode;
StUSDAdapter__factory.abi = _abi;
//# sourceMappingURL=StUSDAdapter__factory.js.map